"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutResponseMapper = void 0;
var CheckoutResponseMapper = /** @class */ (function () {
    function CheckoutResponseMapper(data) {
        this.localData = data;
    }
    CheckoutResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return CheckoutResponseMapper;
}());
exports.CheckoutResponseMapper = CheckoutResponseMapper;
//# sourceMappingURL=CheckoutResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/CheckoutResponseMapper.js
// module id = 2065
// module chunks = 8